import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { resolveTestMode } from './app/shared/test-mode';

if (environment.production) {
  enableProdMode();
}

// Capture the ?test=1 toggle into localStorage before Auth0 bootstraps, so it
// persists even when the first such load lands on the logged-out screen.
resolveTestMode();

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
